export default "987654321111111\n811111111111119\n234234234234278\n818181911112111"